const feVersion = {
    ciBuildNumberTemplate: '20261104.2',
    ciBranchNameTemplate: 'dev',
    ciCommitIdTemplate: 'f3b824fb3b85922456d518fe84d86b69db5bbc15',
    buildNumber: 440,
    version: '3.8.0',
    databaseVersion: 30800,
    shortCommitId: function () {
        if (this.ciCommitIdTemplate.length > 7 && !this.ciCommitIdTemplate.startsWith('#')) {
            return this.ciCommitIdTemplate.substring(0, 7);
        }
        return this.ciCommitIdTemplate;
    }
};

export default feVersion;
